import React from 'react';
import { motion } from 'framer-motion';
import { SectionWrapper } from './SectionWrapper';
import { NeonButton } from './NeonButton';
import { MessageSquareIcon, CheckCircle2Icon, CheckCircleIcon, ArrowRightIcon, UsersIcon, GiftIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://www.tumomentovital.com/cart/47625937879232:1';
const testimonials = [{
  quote: 'Pasé de no poder pedir pizza por teléfono a invitar a salir a la chica que me gustaba en 3 semanas. Los scripts de 3 segundos salvaron mi vida social.',
  name: 'Mateo G.',
  age: 21,
  location: 'Ciudad de México',
  result: '0 ataques de pánico en 1 mes'
}, {
  quote: "Pensé que era 'tímida de nacimiento'. Con Social Hacker entendí que era solo un hábito. Ayer di una presentación en la U y por primera vez no me temblaron las manos.",
  name: 'Valentina R.',
  age: 19,
  location: 'Bogotá, Colombia',
  result: 'Invitada a liderar su grupo de estudio'
}, {
  quote: "El bonus de 'Emergency Calm' es oro puro. Lo escucho antes de entrar a fiestas y mi ansiedad baja de 10 a 2 en minutos.",
  name: 'Lucas S.',
  age: 22,
  location: 'Buenos Aires, Argentina',
  result: 'Su primer grupo de amigos real en años'
}];
export function TestimonialsSection() {
  return <SectionWrapper data-id="element-585">
      <div className="text-center mb-12" data-id="element-586">
        <h2 className="text-2xl md:text-4xl text-white mb-3 font-mono" data-id="element-587">
          LOGS DE{' '}
          <span className="text-cyber-neon text-shadow-neon" data-id="element-588">USUARIOS</span>
        </h2>
        <p className="text-gray-400 font-mono text-sm" data-id="element-589">
          {'//'} RESULTADOS VERIFICADOS
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-10" data-id="element-590">
        {testimonials.map((t, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 25
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: index * 0.15
      }} className="bg-cyber-dark border border-cyber-neon/40 rounded-lg p-5 relative group hover:border-cyber-neon hover:shadow-neon transition-all duration-300" data-id="element-591">
            <div className="absolute top-0 right-0 w-6 h-6 border-t-2 border-r-2 border-cyber-neon rounded-tr-lg opacity-50 group-hover:opacity-100 transition-opacity" data-id="element-592"></div>
            <MessageSquareIcon className="text-cyber-purple w-5 h-5 mb-3 opacity-70" data-id="element-593" />
            <p className="text-gray-300 italic mb-5 text-sm leading-relaxed" data-id="element-594">
              "{t.quote}"
            </p>
            <div className="pt-3 border-t border-gray-800" data-id="element-595">
              <p className="text-white font-bold font-mono text-sm" data-id="element-596">{t.name}</p>
              <p className="text-gray-500 text-xs mb-2" data-id="element-597">
                {t.age} años | {t.location}
              </p>
              <div className="bg-cyber-neon/10 border border-cyber-neon/30 rounded px-2 py-1.5 flex items-start gap-1.5" data-id="element-598">
                <CheckCircle2Icon className="text-cyber-neon w-3.5 h-3.5 shrink-0 mt-0.5" data-id="element-599" />
                <p className="text-cyber-neon text-xs font-mono" data-id="element-600">{t.result}</p>
              </div>
            </div>
          </motion.div>)}
      </div>

      {/* HIGH CONVERSION CTA — after social proof */}
      <div className="text-center bg-cyber-dark/50 border border-cyber-neon/20 rounded-xl p-6 md:p-8" data-id="element-601">
        <div className="flex items-center justify-center gap-2 text-gray-400 text-sm mb-3 font-mono" data-id="element-602">
          <UsersIcon className="w-4 h-4 text-cyber-neon" data-id="element-603" />
          <span data-id="element-604">+200 personas ya hackearon su ansiedad</span>
        </div>
        <NeonButton href={CHECKOUT_URL} size="lg" fullWidth data-id="element-605">
          QUIERO LOS MISMOS RESULTADOS → $9.99{' '}
          <ArrowRightIcon className="w-5 h-5" data-id="element-606" />
        </NeonButton>
        <span className="flex items-center justify-center gap-1.5 text-[11px] font-mono bg-cyber-neon/5 border border-cyber-neon/30 rounded-full px-3 py-1.5 mt-2 shadow-[0_0_8px_rgba(57,255,20,0.1)]" data-id="element-607">
          <GiftIcon className="w-3 h-3 text-cyber-neon animate-pulse" data-id="element-608" />
          <span className="text-gray-300" data-id="element-609">
            + 2 Bonos <strong className="text-cyber-neon" data-id="element-610">GRATIS</strong>{' '}
            incluidos <span className="text-gray-500" data-id="element-611">(valor $47)</span>
          </span>
        </span>
        <div className="bg-cyber-dark/60 border border-cyber-neon/15 rounded-lg p-2.5 space-y-1.5 mt-1" data-id="element-612">
          <div className="flex items-start gap-2" data-id="element-613">
            <CheckCircleIcon className="w-3.5 h-3.5 text-cyber-neon shrink-0 mt-0.5" data-id="element-614" />
            <p className="text-[10px] font-mono text-gray-400 leading-tight" data-id="element-615">
              <span className="text-gray-300 font-bold" data-id="element-616">Bonus 1:</span> Scripts
              de Supervivencia en Citas — qué decir para que nunca haya
              silencios incómodos.
              <span className="ml-1 text-gray-500 line-through" data-id="element-617">$25</span>
              <span className="ml-1 text-cyber-neon font-bold" data-id="element-618">GRATIS</span>
            </p>
          </div>
          <div className="flex items-start gap-2" data-id="element-619">
            <CheckCircleIcon className="w-3.5 h-3.5 text-cyber-neon shrink-0 mt-0.5" data-id="element-620" />
            <p className="text-[10px] font-mono text-gray-400 leading-tight" data-id="element-621">
              <span className="text-gray-300 font-bold" data-id="element-622">Bonus 2:</span>{' '}
              Templates de Texto Irresistibles — para que nunca más te dejen en
              "visto" en WhatsApp.
              <span className="ml-1 text-gray-500 line-through" data-id="element-623">$22</span>
              <span className="ml-1 text-cyber-neon font-bold" data-id="element-624">GRATIS</span>
            </p>
          </div>
          <div className="border-t border-cyber-neon/20 pt-1.5 mt-1" data-id="element-625">
            <p className="text-[11px] font-mono text-cyber-neon font-bold text-center" data-id="element-626">
              Te ahorras $47 USD en bonos de regalo
            </p>
          </div>
        </div>
        <button onClick={() => document.getElementById('bonos')?.scrollIntoView({
        behavior: 'smooth'
      })} className="text-[11px] text-cyber-neon font-mono underline underline-offset-2 hover:text-white transition-colors mt-1" data-id="element-627">
          Leer más
        </button>
      </div>
    </SectionWrapper>;
}